import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { GetAdminV1StoresStoreIdAnalyticsSummaryParams } from '@nucleus-commerce/api-client/admin';

import { analyticsApi } from '../api/analytics-api';

import { analyticsKeys } from './analytics-keys';

export function analyticsSummaryQueryOptions(
  storeId: string,
  { from, to }: GetAdminV1StoresStoreIdAnalyticsSummaryParams,
) {
  return queryOptions({
    queryKey: analyticsKeys.summary(storeId, { from, to }),
    queryFn: () => analyticsApi.summary(storeId, { from, to }),
    placeholderData: keepPreviousData,
  });
}

export function useAnalyticsSummary(
  storeId: string,
  range: GetAdminV1StoresStoreIdAnalyticsSummaryParams,
) {
  return useQuery(analyticsSummaryQueryOptions(storeId, range));
}
